import { render, staticRenderFns } from "./CustomerByPhoneResolver.vue?vue&type=template&id=4d813578&scoped=true&"
import script from "./CustomerByPhoneResolver.vue?vue&type=script&lang=js&"
export * from "./CustomerByPhoneResolver.vue?vue&type=script&lang=js&"
import style0 from "./CustomerByPhoneResolver.vue?vue&type=style&index=0&id=4d813578&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d813578",
  null
  
)

export default component.exports